// Quran reference metadata (114 surahs, 30 juz, sajdah locations).
// Stable, verified structural data shipped with the app so Quran pages render
// instantly and server-side. Ayah text itself lives in the database.

export type Surah = {
  number: number;
  slug: string;
  nameEn: string;
  nameAr: string;
  translationEn: string;
  ayahCount: number;
  revelationPlace: "makkah" | "madinah";
  revelationOrder: number;
  bismillahPre: boolean;
  pages: [number, number];
};

export const SURAHS: Surah[] = [
  {
    "number": 1,
    "slug": "al-fatihah",
    "nameEn": "Al-Fatihah",
    "nameAr": "الفاتحة",
    "translationEn": "The Opener",
    "ayahCount": 7,
    "revelationPlace": "makkah",
    "revelationOrder": 5,
    "bismillahPre": false,
    "pages": [
      1,
      1
    ]
  },
  {
    "number": 2,
    "slug": "al-baqarah",
    "nameEn": "Al-Baqarah",
    "nameAr": "البقرة",
    "translationEn": "The Cow",
    "ayahCount": 286,
    "revelationPlace": "madinah",
    "revelationOrder": 87,
    "bismillahPre": true,
    "pages": [
      2,
      49
    ]
  },
  {
    "number": 3,
    "slug": "ali-imran",
    "nameEn": "Ali 'Imran",
    "nameAr": "آل عمران",
    "translationEn": "Family of Imran",
    "ayahCount": 200,
    "revelationPlace": "madinah",
    "revelationOrder": 89,
    "bismillahPre": true,
    "pages": [
      50,
      76
    ]
  },
  {
    "number": 4,
    "slug": "an-nisa",
    "nameEn": "An-Nisa",
    "nameAr": "النساء",
    "translationEn": "The Women",
    "ayahCount": 176,
    "revelationPlace": "madinah",
    "revelationOrder": 92,
    "bismillahPre": true,
    "pages": [
      77,
      106
    ]
  },
  {
    "number": 5,
    "slug": "al-maidah",
    "nameEn": "Al-Ma'idah",
    "nameAr": "المائدة",
    "translationEn": "The Table Spread",
    "ayahCount": 120,
    "revelationPlace": "madinah",
    "revelationOrder": 112,
    "bismillahPre": true,
    "pages": [
      106,
      127
    ]
  },
  {
    "number": 6,
    "slug": "al-anam",
    "nameEn": "Al-An'am",
    "nameAr": "الأنعام",
    "translationEn": "The Cattle",
    "ayahCount": 165,
    "revelationPlace": "makkah",
    "revelationOrder": 55,
    "bismillahPre": true,
    "pages": [
      128,
      150
    ]
  },
  {
    "number": 7,
    "slug": "al-araf",
    "nameEn": "Al-A'raf",
    "nameAr": "الأعراف",
    "translationEn": "The Heights",
    "ayahCount": 206,
    "revelationPlace": "makkah",
    "revelationOrder": 39,
    "bismillahPre": true,
    "pages": [
      151,
      176
    ]
  },
  {
    "number": 8,
    "slug": "al-anfal",
    "nameEn": "Al-Anfal",
    "nameAr": "الأنفال",
    "translationEn": "The Spoils of War",
    "ayahCount": 75,
    "revelationPlace": "madinah",
    "revelationOrder": 88,
    "bismillahPre": true,
    "pages": [
      177,
      186
    ]
  },
  {
    "number": 9,
    "slug": "at-tawbah",
    "nameEn": "At-Tawbah",
    "nameAr": "التوبة",
    "translationEn": "The Repentance",
    "ayahCount": 129,
    "revelationPlace": "madinah",
    "revelationOrder": 113,
    "bismillahPre": false,
    "pages": [
      187,
      207
    ]
  },
  {
    "number": 10,
    "slug": "yunus",
    "nameEn": "Yunus",
    "nameAr": "يونس",
    "translationEn": "Jonah",
    "ayahCount": 109,
    "revelationPlace": "makkah",
    "revelationOrder": 51,
    "bismillahPre": true,
    "pages": [
      208,
      221
    ]
  },
  {
    "number": 11,
    "slug": "hud",
    "nameEn": "Hud",
    "nameAr": "هود",
    "translationEn": "Hud",
    "ayahCount": 123,
    "revelationPlace": "makkah",
    "revelationOrder": 52,
    "bismillahPre": true,
    "pages": [
      221,
      235
    ]
  },
  {
    "number": 12,
    "slug": "yusuf",
    "nameEn": "Yusuf",
    "nameAr": "يوسف",
    "translationEn": "Joseph",
    "ayahCount": 111,
    "revelationPlace": "makkah",
    "revelationOrder": 53,
    "bismillahPre": true,
    "pages": [
      235,
      248
    ]
  },
  {
    "number": 13,
    "slug": "ar-rad",
    "nameEn": "Ar-Ra'd",
    "nameAr": "الرعد",
    "translationEn": "The Thunder",
    "ayahCount": 43,
    "revelationPlace": "madinah",
    "revelationOrder": 96,
    "bismillahPre": true,
    "pages": [
      249,
      255
    ]
  },
  {
    "number": 14,
    "slug": "ibrahim",
    "nameEn": "Ibrahim",
    "nameAr": "ابراهيم",
    "translationEn": "Abraham",
    "ayahCount": 52,
    "revelationPlace": "makkah",
    "revelationOrder": 72,
    "bismillahPre": true,
    "pages": [
      255,
      261
    ]
  },
  {
    "number": 15,
    "slug": "al-hijr",
    "nameEn": "Al-Hijr",
    "nameAr": "الحجر",
    "translationEn": "The Rocky Tract",
    "ayahCount": 99,
    "revelationPlace": "makkah",
    "revelationOrder": 54,
    "bismillahPre": true,
    "pages": [
      262,
      267
    ]
  },
  {
    "number": 16,
    "slug": "an-nahl",
    "nameEn": "An-Nahl",
    "nameAr": "النحل",
    "translationEn": "The Bee",
    "ayahCount": 128,
    "revelationPlace": "makkah",
    "revelationOrder": 70,
    "bismillahPre": true,
    "pages": [
      267,
      281
    ]
  },
  {
    "number": 17,
    "slug": "al-isra",
    "nameEn": "Al-Isra",
    "nameAr": "الإسراء",
    "translationEn": "The Night Journey",
    "ayahCount": 111,
    "revelationPlace": "makkah",
    "revelationOrder": 50,
    "bismillahPre": true,
    "pages": [
      282,
      293
    ]
  },
  {
    "number": 18,
    "slug": "al-kahf",
    "nameEn": "Al-Kahf",
    "nameAr": "الكهف",
    "translationEn": "The Cave",
    "ayahCount": 110,
    "revelationPlace": "makkah",
    "revelationOrder": 69,
    "bismillahPre": true,
    "pages": [
      293,
      304
    ]
  },
  {
    "number": 19,
    "slug": "maryam",
    "nameEn": "Maryam",
    "nameAr": "مريم",
    "translationEn": "Mary",
    "ayahCount": 98,
    "revelationPlace": "makkah",
    "revelationOrder": 44,
    "bismillahPre": true,
    "pages": [
      305,
      312
    ]
  },
  {
    "number": 20,
    "slug": "taha",
    "nameEn": "Taha",
    "nameAr": "طه",
    "translationEn": "Ta-Ha",
    "ayahCount": 135,
    "revelationPlace": "makkah",
    "revelationOrder": 45,
    "bismillahPre": true,
    "pages": [
      312,
      321
    ]
  },
  {
    "number": 21,
    "slug": "al-anbya",
    "nameEn": "Al-Anbya",
    "nameAr": "الأنبياء",
    "translationEn": "The Prophets",
    "ayahCount": 112,
    "revelationPlace": "makkah",
    "revelationOrder": 73,
    "bismillahPre": true,
    "pages": [
      322,
      331
    ]
  },
  {
    "number": 22,
    "slug": "al-hajj",
    "nameEn": "Al-Hajj",
    "nameAr": "الحج",
    "translationEn": "The Pilgrimage",
    "ayahCount": 78,
    "revelationPlace": "madinah",
    "revelationOrder": 103,
    "bismillahPre": true,
    "pages": [
      332,
      341
    ]
  },
  {
    "number": 23,
    "slug": "al-muminun",
    "nameEn": "Al-Mu'minun",
    "nameAr": "المؤمنون",
    "translationEn": "The Believers",
    "ayahCount": 118,
    "revelationPlace": "makkah",
    "revelationOrder": 74,
    "bismillahPre": true,
    "pages": [
      342,
      349
    ]
  },
  {
    "number": 24,
    "slug": "an-nur",
    "nameEn": "An-Nur",
    "nameAr": "النور",
    "translationEn": "The Light",
    "ayahCount": 64,
    "revelationPlace": "madinah",
    "revelationOrder": 102,
    "bismillahPre": true,
    "pages": [
      350,
      359
    ]
  },
  {
    "number": 25,
    "slug": "al-furqan",
    "nameEn": "Al-Furqan",
    "nameAr": "الفرقان",
    "translationEn": "The Criterion",
    "ayahCount": 77,
    "revelationPlace": "makkah",
    "revelationOrder": 42,
    "bismillahPre": true,
    "pages": [
      359,
      366
    ]
  },
  {
    "number": 26,
    "slug": "ash-shuara",
    "nameEn": "Ash-Shu'ara",
    "nameAr": "الشعراء",
    "translationEn": "The Poets",
    "ayahCount": 227,
    "revelationPlace": "makkah",
    "revelationOrder": 47,
    "bismillahPre": true,
    "pages": [
      367,
      376
    ]
  },
  {
    "number": 27,
    "slug": "an-naml",
    "nameEn": "An-Naml",
    "nameAr": "النمل",
    "translationEn": "The Ant",
    "ayahCount": 93,
    "revelationPlace": "makkah",
    "revelationOrder": 48,
    "bismillahPre": true,
    "pages": [
      377,
      385
    ]
  },
  {
    "number": 28,
    "slug": "al-qasas",
    "nameEn": "Al-Qasas",
    "nameAr": "القصص",
    "translationEn": "The Stories",
    "ayahCount": 88,
    "revelationPlace": "makkah",
    "revelationOrder": 49,
    "bismillahPre": true,
    "pages": [
      385,
      396
    ]
  },
  {
    "number": 29,
    "slug": "al-ankabut",
    "nameEn": "Al-'Ankabut",
    "nameAr": "العنكبوت",
    "translationEn": "The Spider",
    "ayahCount": 69,
    "revelationPlace": "makkah",
    "revelationOrder": 85,
    "bismillahPre": true,
    "pages": [
      396,
      404
    ]
  },
  {
    "number": 30,
    "slug": "ar-rum",
    "nameEn": "Ar-Rum",
    "nameAr": "الروم",
    "translationEn": "The Romans",
    "ayahCount": 60,
    "revelationPlace": "makkah",
    "revelationOrder": 84,
    "bismillahPre": true,
    "pages": [
      404,
      410
    ]
  },
  {
    "number": 31,
    "slug": "luqman",
    "nameEn": "Luqman",
    "nameAr": "لقمان",
    "translationEn": "Luqman",
    "ayahCount": 34,
    "revelationPlace": "makkah",
    "revelationOrder": 57,
    "bismillahPre": true,
    "pages": [
      411,
      414
    ]
  },
  {
    "number": 32,
    "slug": "as-sajdah",
    "nameEn": "As-Sajdah",
    "nameAr": "السجدة",
    "translationEn": "The Prostration",
    "ayahCount": 30,
    "revelationPlace": "makkah",
    "revelationOrder": 75,
    "bismillahPre": true,
    "pages": [
      415,
      417
    ]
  },
  {
    "number": 33,
    "slug": "al-ahzab",
    "nameEn": "Al-Ahzab",
    "nameAr": "الأحزاب",
    "translationEn": "The Combined Forces",
    "ayahCount": 73,
    "revelationPlace": "madinah",
    "revelationOrder": 90,
    "bismillahPre": true,
    "pages": [
      418,
      427
    ]
  },
  {
    "number": 34,
    "slug": "saba",
    "nameEn": "Saba",
    "nameAr": "سبإ",
    "translationEn": "Sheba",
    "ayahCount": 54,
    "revelationPlace": "makkah",
    "revelationOrder": 58,
    "bismillahPre": true,
    "pages": [
      428,
      434
    ]
  },
  {
    "number": 35,
    "slug": "fatir",
    "nameEn": "Fatir",
    "nameAr": "فاطر",
    "translationEn": "Originator",
    "ayahCount": 45,
    "revelationPlace": "makkah",
    "revelationOrder": 43,
    "bismillahPre": true,
    "pages": [
      434,
      440
    ]
  },
  {
    "number": 36,
    "slug": "ya-sin",
    "nameEn": "Ya-Sin",
    "nameAr": "يس",
    "translationEn": "Ya Sin",
    "ayahCount": 83,
    "revelationPlace": "makkah",
    "revelationOrder": 41,
    "bismillahPre": true,
    "pages": [
      440,
      445
    ]
  },
  {
    "number": 37,
    "slug": "as-saffat",
    "nameEn": "As-Saffat",
    "nameAr": "الصافات",
    "translationEn": "Those who set the Ranks",
    "ayahCount": 182,
    "revelationPlace": "makkah",
    "revelationOrder": 56,
    "bismillahPre": true,
    "pages": [
      446,
      452
    ]
  },
  {
    "number": 38,
    "slug": "sad",
    "nameEn": "Sad",
    "nameAr": "ص",
    "translationEn": "The Letter \"Saad\"",
    "ayahCount": 88,
    "revelationPlace": "makkah",
    "revelationOrder": 38,
    "bismillahPre": true,
    "pages": [
      453,
      458
    ]
  },
  {
    "number": 39,
    "slug": "az-zumar",
    "nameEn": "Az-Zumar",
    "nameAr": "الزمر",
    "translationEn": "The Troops",
    "ayahCount": 75,
    "revelationPlace": "makkah",
    "revelationOrder": 59,
    "bismillahPre": true,
    "pages": [
      458,
      467
    ]
  },
  {
    "number": 40,
    "slug": "ghafir",
    "nameEn": "Ghafir",
    "nameAr": "غافر",
    "translationEn": "The Forgiver",
    "ayahCount": 85,
    "revelationPlace": "makkah",
    "revelationOrder": 60,
    "bismillahPre": true,
    "pages": [
      467,
      476
    ]
  },
  {
    "number": 41,
    "slug": "fussilat",
    "nameEn": "Fussilat",
    "nameAr": "فصلت",
    "translationEn": "Explained in Detail",
    "ayahCount": 54,
    "revelationPlace": "makkah",
    "revelationOrder": 61,
    "bismillahPre": true,
    "pages": [
      477,
      482
    ]
  },
  {
    "number": 42,
    "slug": "ash-shuraa",
    "nameEn": "Ash-Shuraa",
    "nameAr": "الشورى",
    "translationEn": "The Consultation",
    "ayahCount": 53,
    "revelationPlace": "makkah",
    "revelationOrder": 62,
    "bismillahPre": true,
    "pages": [
      483,
      489
    ]
  },
  {
    "number": 43,
    "slug": "az-zukhruf",
    "nameEn": "Az-Zukhruf",
    "nameAr": "الزخرف",
    "translationEn": "The Ornaments of Gold",
    "ayahCount": 89,
    "revelationPlace": "makkah",
    "revelationOrder": 63,
    "bismillahPre": true,
    "pages": [
      489,
      495
    ]
  },
  {
    "number": 44,
    "slug": "ad-dukhan",
    "nameEn": "Ad-Dukhan",
    "nameAr": "الدخان",
    "translationEn": "The Smoke",
    "ayahCount": 59,
    "revelationPlace": "makkah",
    "revelationOrder": 64,
    "bismillahPre": true,
    "pages": [
      496,
      498
    ]
  },
  {
    "number": 45,
    "slug": "al-jathiyah",
    "nameEn": "Al-Jathiyah",
    "nameAr": "الجاثية",
    "translationEn": "The Crouching",
    "ayahCount": 37,
    "revelationPlace": "makkah",
    "revelationOrder": 65,
    "bismillahPre": true,
    "pages": [
      499,
      502
    ]
  },
  {
    "number": 46,
    "slug": "al-ahqaf",
    "nameEn": "Al-Ahqaf",
    "nameAr": "الأحقاف",
    "translationEn": "The Wind-Curved Sandhills",
    "ayahCount": 35,
    "revelationPlace": "makkah",
    "revelationOrder": 66,
    "bismillahPre": true,
    "pages": [
      502,
      506
    ]
  },
  {
    "number": 47,
    "slug": "muhammad",
    "nameEn": "Muhammad",
    "nameAr": "محمد",
    "translationEn": "Muhammad",
    "ayahCount": 38,
    "revelationPlace": "madinah",
    "revelationOrder": 95,
    "bismillahPre": true,
    "pages": [
      507,
      510
    ]
  },
  {
    "number": 48,
    "slug": "al-fath",
    "nameEn": "Al-Fath",
    "nameAr": "الفتح",
    "translationEn": "The Victory",
    "ayahCount": 29,
    "revelationPlace": "madinah",
    "revelationOrder": 111,
    "bismillahPre": true,
    "pages": [
      511,
      515
    ]
  },
  {
    "number": 49,
    "slug": "al-hujurat",
    "nameEn": "Al-Hujurat",
    "nameAr": "الحجرات",
    "translationEn": "The Rooms",
    "ayahCount": 18,
    "revelationPlace": "madinah",
    "revelationOrder": 106,
    "bismillahPre": true,
    "pages": [
      515,
      517
    ]
  },
  {
    "number": 50,
    "slug": "qaf",
    "nameEn": "Qaf",
    "nameAr": "ق",
    "translationEn": "The Letter \"Qaf\"",
    "ayahCount": 45,
    "revelationPlace": "makkah",
    "revelationOrder": 34,
    "bismillahPre": true,
    "pages": [
      518,
      520
    ]
  },
  {
    "number": 51,
    "slug": "adh-dhariyat",
    "nameEn": "Adh-Dhariyat",
    "nameAr": "الذاريات",
    "translationEn": "The Winnowing Winds",
    "ayahCount": 60,
    "revelationPlace": "makkah",
    "revelationOrder": 67,
    "bismillahPre": true,
    "pages": [
      520,
      523
    ]
  },
  {
    "number": 52,
    "slug": "at-tur",
    "nameEn": "At-Tur",
    "nameAr": "الطور",
    "translationEn": "The Mount",
    "ayahCount": 49,
    "revelationPlace": "makkah",
    "revelationOrder": 76,
    "bismillahPre": true,
    "pages": [
      523,
      525
    ]
  },
  {
    "number": 53,
    "slug": "an-najm",
    "nameEn": "An-Najm",
    "nameAr": "النجم",
    "translationEn": "The Star",
    "ayahCount": 62,
    "revelationPlace": "makkah",
    "revelationOrder": 23,
    "bismillahPre": true,
    "pages": [
      526,
      528
    ]
  },
  {
    "number": 54,
    "slug": "al-qamar",
    "nameEn": "Al-Qamar",
    "nameAr": "القمر",
    "translationEn": "The Moon",
    "ayahCount": 55,
    "revelationPlace": "makkah",
    "revelationOrder": 37,
    "bismillahPre": true,
    "pages": [
      528,
      531
    ]
  },
  {
    "number": 55,
    "slug": "ar-rahman",
    "nameEn": "Ar-Rahman",
    "nameAr": "الرحمن",
    "translationEn": "The Beneficent",
    "ayahCount": 78,
    "revelationPlace": "madinah",
    "revelationOrder": 97,
    "bismillahPre": true,
    "pages": [
      531,
      534
    ]
  },
  {
    "number": 56,
    "slug": "al-waqiah",
    "nameEn": "Al-Waqi'ah",
    "nameAr": "الواقعة",
    "translationEn": "The Inevitable",
    "ayahCount": 96,
    "revelationPlace": "makkah",
    "revelationOrder": 46,
    "bismillahPre": true,
    "pages": [
      534,
      537
    ]
  },
  {
    "number": 57,
    "slug": "al-hadid",
    "nameEn": "Al-Hadid",
    "nameAr": "الحديد",
    "translationEn": "The Iron",
    "ayahCount": 29,
    "revelationPlace": "madinah",
    "revelationOrder": 94,
    "bismillahPre": true,
    "pages": [
      537,
      541
    ]
  },
  {
    "number": 58,
    "slug": "al-mujadila",
    "nameEn": "Al-Mujadila",
    "nameAr": "المجادلة",
    "translationEn": "The Pleading Woman",
    "ayahCount": 22,
    "revelationPlace": "madinah",
    "revelationOrder": 105,
    "bismillahPre": true,
    "pages": [
      542,
      545
    ]
  },
  {
    "number": 59,
    "slug": "al-hashr",
    "nameEn": "Al-Hashr",
    "nameAr": "الحشر",
    "translationEn": "The Exile",
    "ayahCount": 24,
    "revelationPlace": "madinah",
    "revelationOrder": 101,
    "bismillahPre": true,
    "pages": [
      545,
      548
    ]
  },
  {
    "number": 60,
    "slug": "al-mumtahanah",
    "nameEn": "Al-Mumtahanah",
    "nameAr": "الممتحنة",
    "translationEn": "She that is to be examined",
    "ayahCount": 13,
    "revelationPlace": "madinah",
    "revelationOrder": 91,
    "bismillahPre": true,
    "pages": [
      549,
      551
    ]
  },
  {
    "number": 61,
    "slug": "as-saf",
    "nameEn": "As-Saf",
    "nameAr": "الصف",
    "translationEn": "The Ranks",
    "ayahCount": 14,
    "revelationPlace": "madinah",
    "revelationOrder": 109,
    "bismillahPre": true,
    "pages": [
      551,
      552
    ]
  },
  {
    "number": 62,
    "slug": "al-jumuah",
    "nameEn": "Al-Jumu'ah",
    "nameAr": "الجمعة",
    "translationEn": "The Congregation, Friday",
    "ayahCount": 11,
    "revelationPlace": "madinah",
    "revelationOrder": 110,
    "bismillahPre": true,
    "pages": [
      553,
      554
    ]
  },
  {
    "number": 63,
    "slug": "al-munafiqun",
    "nameEn": "Al-Munafiqun",
    "nameAr": "المنافقون",
    "translationEn": "The Hypocrites",
    "ayahCount": 11,
    "revelationPlace": "madinah",
    "revelationOrder": 104,
    "bismillahPre": true,
    "pages": [
      554,
      555
    ]
  },
  {
    "number": 64,
    "slug": "at-taghabun",
    "nameEn": "At-Taghabun",
    "nameAr": "التغابن",
    "translationEn": "The Mutual Disillusion",
    "ayahCount": 18,
    "revelationPlace": "madinah",
    "revelationOrder": 108,
    "bismillahPre": true,
    "pages": [
      556,
      557
    ]
  },
  {
    "number": 65,
    "slug": "at-talaq",
    "nameEn": "At-Talaq",
    "nameAr": "الطلاق",
    "translationEn": "The Divorce",
    "ayahCount": 12,
    "revelationPlace": "madinah",
    "revelationOrder": 99,
    "bismillahPre": true,
    "pages": [
      558,
      559
    ]
  },
  {
    "number": 66,
    "slug": "at-tahrim",
    "nameEn": "At-Tahrim",
    "nameAr": "التحريم",
    "translationEn": "The Prohibition",
    "ayahCount": 12,
    "revelationPlace": "madinah",
    "revelationOrder": 107,
    "bismillahPre": true,
    "pages": [
      560,
      561
    ]
  },
  {
    "number": 67,
    "slug": "al-mulk",
    "nameEn": "Al-Mulk",
    "nameAr": "الملك",
    "translationEn": "The Sovereignty",
    "ayahCount": 30,
    "revelationPlace": "makkah",
    "revelationOrder": 77,
    "bismillahPre": true,
    "pages": [
      562,
      564
    ]
  },
  {
    "number": 68,
    "slug": "al-qalam",
    "nameEn": "Al-Qalam",
    "nameAr": "القلم",
    "translationEn": "The Pen",
    "ayahCount": 52,
    "revelationPlace": "makkah",
    "revelationOrder": 2,
    "bismillahPre": true,
    "pages": [
      564,
      566
    ]
  },
  {
    "number": 69,
    "slug": "al-haqqah",
    "nameEn": "Al-Haqqah",
    "nameAr": "الحاقة",
    "translationEn": "The Reality",
    "ayahCount": 52,
    "revelationPlace": "makkah",
    "revelationOrder": 78,
    "bismillahPre": true,
    "pages": [
      566,
      568
    ]
  },
  {
    "number": 70,
    "slug": "al-maarij",
    "nameEn": "Al-Ma'arij",
    "nameAr": "المعارج",
    "translationEn": "The Ascending Stairways",
    "ayahCount": 44,
    "revelationPlace": "makkah",
    "revelationOrder": 79,
    "bismillahPre": true,
    "pages": [
      568,
      570
    ]
  },
  {
    "number": 71,
    "slug": "nuh",
    "nameEn": "Nuh",
    "nameAr": "نوح",
    "translationEn": "Noah",
    "ayahCount": 28,
    "revelationPlace": "makkah",
    "revelationOrder": 71,
    "bismillahPre": true,
    "pages": [
      570,
      571
    ]
  },
  {
    "number": 72,
    "slug": "al-jinn",
    "nameEn": "Al-Jinn",
    "nameAr": "الجن",
    "translationEn": "The Jinn",
    "ayahCount": 28,
    "revelationPlace": "makkah",
    "revelationOrder": 40,
    "bismillahPre": true,
    "pages": [
      572,
      573
    ]
  },
  {
    "number": 73,
    "slug": "al-muzzammil",
    "nameEn": "Al-Muzzammil",
    "nameAr": "المزمل",
    "translationEn": "The Enshrouded One",
    "ayahCount": 20,
    "revelationPlace": "makkah",
    "revelationOrder": 3,
    "bismillahPre": true,
    "pages": [
      574,
      575
    ]
  },
  {
    "number": 74,
    "slug": "al-muddaththir",
    "nameEn": "Al-Muddaththir",
    "nameAr": "المدثر",
    "translationEn": "The Cloaked One",
    "ayahCount": 56,
    "revelationPlace": "makkah",
    "revelationOrder": 4,
    "bismillahPre": true,
    "pages": [
      575,
      577
    ]
  },
  {
    "number": 75,
    "slug": "al-qiyamah",
    "nameEn": "Al-Qiyamah",
    "nameAr": "القيامة",
    "translationEn": "The Resurrection",
    "ayahCount": 40,
    "revelationPlace": "makkah",
    "revelationOrder": 31,
    "bismillahPre": true,
    "pages": [
      577,
      578
    ]
  },
  {
    "number": 76,
    "slug": "al-insan",
    "nameEn": "Al-Insan",
    "nameAr": "الانسان",
    "translationEn": "The Man",
    "ayahCount": 31,
    "revelationPlace": "madinah",
    "revelationOrder": 98,
    "bismillahPre": true,
    "pages": [
      578,
      580
    ]
  },
  {
    "number": 77,
    "slug": "al-mursalat",
    "nameEn": "Al-Mursalat",
    "nameAr": "المرسلات",
    "translationEn": "The Emissaries",
    "ayahCount": 50,
    "revelationPlace": "makkah",
    "revelationOrder": 33,
    "bismillahPre": true,
    "pages": [
      580,
      581
    ]
  },
  {
    "number": 78,
    "slug": "an-naba",
    "nameEn": "An-Naba",
    "nameAr": "النبإ",
    "translationEn": "The Tidings",
    "ayahCount": 40,
    "revelationPlace": "makkah",
    "revelationOrder": 80,
    "bismillahPre": true,
    "pages": [
      582,
      583
    ]
  },
  {
    "number": 79,
    "slug": "an-naziat",
    "nameEn": "An-Nazi'at",
    "nameAr": "النازعات",
    "translationEn": "Those who drag forth",
    "ayahCount": 46,
    "revelationPlace": "makkah",
    "revelationOrder": 81,
    "bismillahPre": true,
    "pages": [
      583,
      584
    ]
  },
  {
    "number": 80,
    "slug": "abasa",
    "nameEn": "'Abasa",
    "nameAr": "عبس",
    "translationEn": "He Frowned",
    "ayahCount": 42,
    "revelationPlace": "makkah",
    "revelationOrder": 24,
    "bismillahPre": true,
    "pages": [
      585,
      585
    ]
  },
  {
    "number": 81,
    "slug": "at-takwir",
    "nameEn": "At-Takwir",
    "nameAr": "التكوير",
    "translationEn": "The Overthrowing",
    "ayahCount": 29,
    "revelationPlace": "makkah",
    "revelationOrder": 7,
    "bismillahPre": true,
    "pages": [
      586,
      586
    ]
  },
  {
    "number": 82,
    "slug": "al-infitar",
    "nameEn": "Al-Infitar",
    "nameAr": "الإنفطار",
    "translationEn": "The Cleaving",
    "ayahCount": 19,
    "revelationPlace": "makkah",
    "revelationOrder": 82,
    "bismillahPre": true,
    "pages": [
      587,
      587
    ]
  },
  {
    "number": 83,
    "slug": "al-mutaffifin",
    "nameEn": "Al-Mutaffifin",
    "nameAr": "المطففين",
    "translationEn": "The Defrauding",
    "ayahCount": 36,
    "revelationPlace": "makkah",
    "revelationOrder": 86,
    "bismillahPre": true,
    "pages": [
      587,
      589
    ]
  },
  {
    "number": 84,
    "slug": "al-inshiqaq",
    "nameEn": "Al-Inshiqaq",
    "nameAr": "الإنشقاق",
    "translationEn": "The Sundering",
    "ayahCount": 25,
    "revelationPlace": "makkah",
    "revelationOrder": 83,
    "bismillahPre": true,
    "pages": [
      589,
      589
    ]
  },
  {
    "number": 85,
    "slug": "al-buruj",
    "nameEn": "Al-Buruj",
    "nameAr": "البروج",
    "translationEn": "The Mansions of the Stars",
    "ayahCount": 22,
    "revelationPlace": "makkah",
    "revelationOrder": 27,
    "bismillahPre": true,
    "pages": [
      590,
      590
    ]
  },
  {
    "number": 86,
    "slug": "at-tariq",
    "nameEn": "At-Tariq",
    "nameAr": "الطارق",
    "translationEn": "The Nightcommer",
    "ayahCount": 17,
    "revelationPlace": "makkah",
    "revelationOrder": 36,
    "bismillahPre": true,
    "pages": [
      591,
      591
    ]
  },
  {
    "number": 87,
    "slug": "al-ala",
    "nameEn": "Al-A'la",
    "nameAr": "الأعلى",
    "translationEn": "The Most High",
    "ayahCount": 19,
    "revelationPlace": "makkah",
    "revelationOrder": 8,
    "bismillahPre": true,
    "pages": [
      591,
      592
    ]
  },
  {
    "number": 88,
    "slug": "al-ghashiyah",
    "nameEn": "Al-Ghashiyah",
    "nameAr": "الغاشية",
    "translationEn": "The Overwhelming",
    "ayahCount": 26,
    "revelationPlace": "makkah",
    "revelationOrder": 68,
    "bismillahPre": true,
    "pages": [
      592,
      592
    ]
  },
  {
    "number": 89,
    "slug": "al-fajr",
    "nameEn": "Al-Fajr",
    "nameAr": "الفجر",
    "translationEn": "The Dawn",
    "ayahCount": 30,
    "revelationPlace": "makkah",
    "revelationOrder": 10,
    "bismillahPre": true,
    "pages": [
      593,
      594
    ]
  },
  {
    "number": 90,
    "slug": "al-balad",
    "nameEn": "Al-Balad",
    "nameAr": "البلد",
    "translationEn": "The City",
    "ayahCount": 20,
    "revelationPlace": "makkah",
    "revelationOrder": 35,
    "bismillahPre": true,
    "pages": [
      594,
      594
    ]
  },
  {
    "number": 91,
    "slug": "ash-shams",
    "nameEn": "Ash-Shams",
    "nameAr": "الشمس",
    "translationEn": "The Sun",
    "ayahCount": 15,
    "revelationPlace": "makkah",
    "revelationOrder": 26,
    "bismillahPre": true,
    "pages": [
      595,
      595
    ]
  },
  {
    "number": 92,
    "slug": "al-layl",
    "nameEn": "Al-Layl",
    "nameAr": "الليل",
    "translationEn": "The Night",
    "ayahCount": 21,
    "revelationPlace": "makkah",
    "revelationOrder": 9,
    "bismillahPre": true,
    "pages": [
      595,
      596
    ]
  },
  {
    "number": 93,
    "slug": "ad-duhaa",
    "nameEn": "Ad-Duhaa",
    "nameAr": "الضحى",
    "translationEn": "The Morning Hours",
    "ayahCount": 11,
    "revelationPlace": "makkah",
    "revelationOrder": 11,
    "bismillahPre": true,
    "pages": [
      596,
      596
    ]
  },
  {
    "number": 94,
    "slug": "ash-sharh",
    "nameEn": "Ash-Sharh",
    "nameAr": "الشرح",
    "translationEn": "The Relief",
    "ayahCount": 8,
    "revelationPlace": "makkah",
    "revelationOrder": 12,
    "bismillahPre": true,
    "pages": [
      596,
      596
    ]
  },
  {
    "number": 95,
    "slug": "at-tin",
    "nameEn": "At-Tin",
    "nameAr": "التين",
    "translationEn": "The Fig",
    "ayahCount": 8,
    "revelationPlace": "makkah",
    "revelationOrder": 28,
    "bismillahPre": true,
    "pages": [
      597,
      597
    ]
  },
  {
    "number": 96,
    "slug": "al-alaq",
    "nameEn": "Al-'Alaq",
    "nameAr": "العلق",
    "translationEn": "The Clot",
    "ayahCount": 19,
    "revelationPlace": "makkah",
    "revelationOrder": 1,
    "bismillahPre": true,
    "pages": [
      597,
      597
    ]
  },
  {
    "number": 97,
    "slug": "al-qadr",
    "nameEn": "Al-Qadr",
    "nameAr": "القدر",
    "translationEn": "The Power",
    "ayahCount": 5,
    "revelationPlace": "makkah",
    "revelationOrder": 25,
    "bismillahPre": true,
    "pages": [
      598,
      598
    ]
  },
  {
    "number": 98,
    "slug": "al-bayyinah",
    "nameEn": "Al-Bayyinah",
    "nameAr": "البينة",
    "translationEn": "The Clear Proof",
    "ayahCount": 8,
    "revelationPlace": "madinah",
    "revelationOrder": 100,
    "bismillahPre": true,
    "pages": [
      598,
      599
    ]
  },
  {
    "number": 99,
    "slug": "az-zalzalah",
    "nameEn": "Az-Zalzalah",
    "nameAr": "الزلزلة",
    "translationEn": "The Earthquake",
    "ayahCount": 8,
    "revelationPlace": "madinah",
    "revelationOrder": 93,
    "bismillahPre": true,
    "pages": [
      599,
      599
    ]
  },
  {
    "number": 100,
    "slug": "al-adiyat",
    "nameEn": "Al-'Adiyat",
    "nameAr": "العاديات",
    "translationEn": "The Courser",
    "ayahCount": 11,
    "revelationPlace": "makkah",
    "revelationOrder": 14,
    "bismillahPre": true,
    "pages": [
      599,
      600
    ]
  },
  {
    "number": 101,
    "slug": "al-qariah",
    "nameEn": "Al-Qari'ah",
    "nameAr": "القارعة",
    "translationEn": "The Calamity",
    "ayahCount": 11,
    "revelationPlace": "makkah",
    "revelationOrder": 30,
    "bismillahPre": true,
    "pages": [
      600,
      600
    ]
  },
  {
    "number": 102,
    "slug": "at-takathur",
    "nameEn": "At-Takathur",
    "nameAr": "التكاثر",
    "translationEn": "The Rivalry in world increase",
    "ayahCount": 8,
    "revelationPlace": "makkah",
    "revelationOrder": 16,
    "bismillahPre": true,
    "pages": [
      600,
      600
    ]
  },
  {
    "number": 103,
    "slug": "al-asr",
    "nameEn": "Al-'Asr",
    "nameAr": "العصر",
    "translationEn": "The Declining Day",
    "ayahCount": 3,
    "revelationPlace": "makkah",
    "revelationOrder": 13,
    "bismillahPre": true,
    "pages": [
      601,
      601
    ]
  },
  {
    "number": 104,
    "slug": "al-humazah",
    "nameEn": "Al-Humazah",
    "nameAr": "الهمزة",
    "translationEn": "The Traducer",
    "ayahCount": 9,
    "revelationPlace": "makkah",
    "revelationOrder": 32,
    "bismillahPre": true,
    "pages": [
      601,
      601
    ]
  },
  {
    "number": 105,
    "slug": "al-fil",
    "nameEn": "Al-Fil",
    "nameAr": "الفيل",
    "translationEn": "The Elephant",
    "ayahCount": 5,
    "revelationPlace": "makkah",
    "revelationOrder": 19,
    "bismillahPre": true,
    "pages": [
      601,
      601
    ]
  },
  {
    "number": 106,
    "slug": "quraysh",
    "nameEn": "Quraysh",
    "nameAr": "قريش",
    "translationEn": "Quraysh",
    "ayahCount": 4,
    "revelationPlace": "makkah",
    "revelationOrder": 29,
    "bismillahPre": true,
    "pages": [
      602,
      602
    ]
  },
  {
    "number": 107,
    "slug": "al-maun",
    "nameEn": "Al-Ma'un",
    "nameAr": "الماعون",
    "translationEn": "The Small kindnesses",
    "ayahCount": 7,
    "revelationPlace": "makkah",
    "revelationOrder": 17,
    "bismillahPre": true,
    "pages": [
      602,
      602
    ]
  },
  {
    "number": 108,
    "slug": "al-kawthar",
    "nameEn": "Al-Kawthar",
    "nameAr": "الكوثر",
    "translationEn": "The Abundance",
    "ayahCount": 3,
    "revelationPlace": "makkah",
    "revelationOrder": 15,
    "bismillahPre": true,
    "pages": [
      602,
      602
    ]
  },
  {
    "number": 109,
    "slug": "al-kafirun",
    "nameEn": "Al-Kafirun",
    "nameAr": "الكافرون",
    "translationEn": "The Disbelievers",
    "ayahCount": 6,
    "revelationPlace": "makkah",
    "revelationOrder": 18,
    "bismillahPre": true,
    "pages": [
      603,
      603
    ]
  },
  {
    "number": 110,
    "slug": "an-nasr",
    "nameEn": "An-Nasr",
    "nameAr": "النصر",
    "translationEn": "The Divine Support",
    "ayahCount": 3,
    "revelationPlace": "madinah",
    "revelationOrder": 114,
    "bismillahPre": true,
    "pages": [
      603,
      603
    ]
  },
  {
    "number": 111,
    "slug": "al-masad",
    "nameEn": "Al-Masad",
    "nameAr": "المسد",
    "translationEn": "The Palm Fiber",
    "ayahCount": 5,
    "revelationPlace": "makkah",
    "revelationOrder": 6,
    "bismillahPre": true,
    "pages": [
      603,
      603
    ]
  },
  {
    "number": 112,
    "slug": "al-ikhlas",
    "nameEn": "Al-Ikhlas",
    "nameAr": "الإخلاص",
    "translationEn": "The Sincerity",
    "ayahCount": 4,
    "revelationPlace": "makkah",
    "revelationOrder": 22,
    "bismillahPre": true,
    "pages": [
      604,
      604
    ]
  },
  {
    "number": 113,
    "slug": "al-falaq",
    "nameEn": "Al-Falaq",
    "nameAr": "الفلق",
    "translationEn": "The Daybreak",
    "ayahCount": 5,
    "revelationPlace": "makkah",
    "revelationOrder": 20,
    "bismillahPre": true,
    "pages": [
      604,
      604
    ]
  },
  {
    "number": 114,
    "slug": "an-nas",
    "nameEn": "An-Nas",
    "nameAr": "الناس",
    "translationEn": "Mankind",
    "ayahCount": 6,
    "revelationPlace": "makkah",
    "revelationOrder": 21,
    "bismillahPre": true,
    "pages": [
      604,
      604
    ]
  }
];

export const JUZ_STARTS: { number: number; surah: number; ayah: number }[] = [{"number": 1, "surah": 1, "ayah": 1}, {"number": 2, "surah": 2, "ayah": 142}, {"number": 3, "surah": 2, "ayah": 253}, {"number": 4, "surah": 3, "ayah": 93}, {"number": 5, "surah": 4, "ayah": 24}, {"number": 6, "surah": 4, "ayah": 148}, {"number": 7, "surah": 5, "ayah": 82}, {"number": 8, "surah": 6, "ayah": 111}, {"number": 9, "surah": 7, "ayah": 88}, {"number": 10, "surah": 8, "ayah": 41}, {"number": 11, "surah": 9, "ayah": 93}, {"number": 12, "surah": 11, "ayah": 6}, {"number": 13, "surah": 12, "ayah": 53}, {"number": 14, "surah": 15, "ayah": 1}, {"number": 15, "surah": 17, "ayah": 1}, {"number": 16, "surah": 18, "ayah": 75}, {"number": 17, "surah": 21, "ayah": 1}, {"number": 18, "surah": 23, "ayah": 1}, {"number": 19, "surah": 25, "ayah": 21}, {"number": 20, "surah": 27, "ayah": 56}, {"number": 21, "surah": 29, "ayah": 46}, {"number": 22, "surah": 33, "ayah": 31}, {"number": 23, "surah": 36, "ayah": 28}, {"number": 24, "surah": 39, "ayah": 32}, {"number": 25, "surah": 41, "ayah": 47}, {"number": 26, "surah": 46, "ayah": 1}, {"number": 27, "surah": 51, "ayah": 31}, {"number": 28, "surah": 58, "ayah": 1}, {"number": 29, "surah": 67, "ayah": 1}, {"number": 30, "surah": 78, "ayah": 1}];

export const SAJDAH_AYAHS: { surah: number; ayah: number; recommended: boolean }[] = [{"surah": 7, "ayah": 206, "recommended": true}, {"surah": 13, "ayah": 15, "recommended": true}, {"surah": 16, "ayah": 50, "recommended": true}, {"surah": 17, "ayah": 109, "recommended": true}, {"surah": 19, "ayah": 58, "recommended": true}, {"surah": 22, "ayah": 18, "recommended": true}, {"surah": 22, "ayah": 77, "recommended": true}, {"surah": 25, "ayah": 60, "recommended": true}, {"surah": 27, "ayah": 26, "recommended": true}, {"surah": 32, "ayah": 15, "recommended": false}, {"surah": 38, "ayah": 24, "recommended": true}, {"surah": 41, "ayah": 38, "recommended": false}, {"surah": 53, "ayah": 62, "recommended": false}, {"surah": 84, "ayah": 21, "recommended": true}, {"surah": 96, "ayah": 19, "recommended": false}];

export const TOTAL_AYAHS = SURAHS.reduce((sum, s) => sum + s.ayahCount, 0);

export function getSurahBySlug(slug: string): Surah | undefined {
  return SURAHS.find((s) => s.slug === slug);
}

export function getSurahByNumber(n: number): Surah | undefined {
  return SURAHS.find((s) => s.number === n);
}

export function juzForAyah(surah: number, ayah: number): number {
  let current = 1;
  for (const j of JUZ_STARTS) {
    if (j.surah < surah || (j.surah === surah && j.ayah <= ayah)) current = j.number;
    else break;
  }
  return current;
}

export function isSajdahAyah(surah: number, ayah: number): boolean {
  return SAJDAH_AYAHS.some((s) => s.surah === surah && s.ayah === ayah);
}
